export async function optOutListenerSupport(userId: string) {
  try {
    const response = await fetch(
      '/api/proxy/v3/supporter/disableListenerSupport',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          userId,
        }),
      }
    );
    if (!response.ok) {
      throw new Error('Could not opt out of listener support');
    }
  } catch (err) {
    throw new Error(err.message);
  }
}
